import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useAnalytics } from '@provider-directory/components/analytics/analytics-provider';
import { useOrgContext } from '@provider-directory/components/org-context/org-context-provider';
import { HeaderLanguageSelector } from './header-language-selector';

export interface UtilityLink {
  text: string;
  link: { href: string; target: string };
  leadingIcon?: {
    name: string;
    size: string;
  };
}

interface HeaderUtilityMenuProps {
  leftLinks: UtilityLink[];
  rightLinks: UtilityLink[];
}

export const HeaderUtilityMenu: React.FC<HeaderUtilityMenuProps> = ({
  leftLinks,
  rightLinks,
}) => {
  const { key } = useOrgContext();
  const { t } = useTranslation(key);
  const analytics = useAnalytics();
  return (
    <div className={'bg-primary-montefiore-500 lg:block relative z-10 hidden'}>
      <div className={'mf-wrap'}>
        <div className={'flex items-center justify-between gap-32'}>
          {/* Left links */}
          <nav
            className={'mf-top-bar-menu -translate-x-14'}
            aria-label={t('aria.utilityNavigationLeft')}
          >
            <div className={'fabric-block hidden'}>
              <ul className={'mf-top-bar-menu__list'}>
                {leftLinks.map((menuItem, index) => (
                  <li
                    className={'relative inline-block align-bottom'}
                    key={index}
                  >
                    <a
                      className={clsx(
                        'mf-link mf-link--site-montefiore mf-link--light mf-link--base mf-link--direction-backwards mf-link--animation-reverse mf-top-bar-menu__link',
                        index === 0 &&
                          'mf-link--dark mf-top-bar-menu__link--active',
                      )}
                      onClick={() => {
                        analytics.navigationClickEvent({
                          navigationType: 'top-bar',
                          linkType: 'link',
                          clickText: menuItem.text,
                        });
                      }}
                      href={menuItem.link.href}
                      data-analytics-click-text={menuItem.text}
                      data-analytics-link-type={'link'}
                    >
                      <span className={'mf-link__text'}>
                        <span className={'mf-link__text__inner'}>
                          {t(menuItem.text)}
                        </span>
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </nav>

          {/* Right links */}
          <nav
            className={'mf-top-bar-menu'}
            aria-label={t('aria.utilityNavigationRight')}
          >
            <ul className={'mf-top-bar-menu__list'}>
              {rightLinks.map((menuItem, index) => (
                <li
                  className={'relative inline-block align-bottom'}
                  key={index}
                >
                  <a
                    className={
                      'mf-link mf-link--site-montefiore mf-link--light mf-link--base mf-link--direction-backwards mf-link--animation-reverse mf-top-bar-menu__link'
                    }
                    onClick={() => {
                      analytics.navigationClickEvent({
                        navigationType: 'top-bar',
                        linkType: 'link',
                        clickText: menuItem.text,
                      });
                    }}
                    href={menuItem.link.href}
                    data-analytics-click-text={menuItem.text}
                    data-analytics-link-type={'link'}
                  >
                    <span className={'mf-link__text'}>
                      <span className={'mf-link__text__inner'}>
                        {t(menuItem.text)}
                      </span>
                    </span>
                  </a>
                </li>
              ))}

              {/* Languages */}
              <HeaderLanguageSelector />
            </ul>
          </nav>
        </div>
      </div>
    </div>
  );
};
